import React from 'react';
import { Button, Row, Col } from 'antd';

/**
 * Price Component
 * @param item
 * @param jpy
 * @returns {*}
 * @constructor
 */
export const Price = ({item, jpy}) => (
  <div>
    <div className='font-weight-bold fs-xs text-right mb-0'>
      <span className='mr-1'>豪ドル</span>
      <span className='card-travel__before'>${item.getIn(['prices', 'adult_orig'])}</span>
      <span className='text-success h3 font-weight-bold ml-1'>${item.get('price')}</span>
    </div>
    {jpy &&
    <div className='font-weight-bold fs-xs text-right mb-0'>
      {item.get('price') &&
      <span className='dimio-jpy'> (約{parseInt(item.get('price')) * parseInt(jpy)}円)</span>
      }
    </div>
    }
  </div>
);

/**
 * List/Card Item Component
 * @param item
 * @param jpy
 * @returns {*}
 * @constructor
 */
export const Item = ({item, jpy}) => (
  <a className='card card-travel mb-4' href={item.get('url')}>
    <img className='card-travel__label' src='https://tora-tora.net/js/Bootstrap4-alpha6/dev/images/icon/sale.svg' alt={`${item.get('name')} - セール`}/>
    <Row type='flex' gutter={8}>
      <Col xs={8} md={24}>
        <img className='border-1 rounded mb-2' src={item.get('thumb')} alt=''/>
      </Col>
      <Col xs={16} md={24}>
        <div className='fs-xs text-primary'>{item.get('city_name')}</div>
        <h3 className='card-travel__title mb-0'>{item.get('name')}</h3>
        <hr/>
        <div className='card-travel__plan'>{item.get('plan_name')}</div>
        <Price item={item} jpy={jpy}/>
      </Col>
    </Row>
  </a>
);




// WEBPACK FOOTER //
// ./src/pages/travel/components/Library.js